import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const UPI_ID = "sohankmr26-2@okaxis";
export const UPI_NAME = "Hemozy Diagnostics";
export const PHONE = "+91 97766 15544";
export const PHONE_RAW = "919776615544";
export const EMAILS = ["wecare@hemozy.com", "sohan@hemozy.com"];
export const ADDRESS = "MVP Colony, Visakhapatnam, Andhra Pradesh";

export function buildUpiLink(amount, note) {
  return `upi://pay?pa=${UPI_ID}&pn=${encodeURIComponent(UPI_NAME)}&am=${amount}&cu=INR&tn=${encodeURIComponent(note)}`;
}
